 export enum DownloadType {
    Excel,
    PDF
}
